import { combineReducers } from 'redux';

import departmentTemplatesReducer, { DepartmentTemplatesState } from './departmentTemplates/reducer';
import feedbackReducer, { FeedbackState } from './feedback/reducer';
import foodTrayTemplateEditReducer, { FoodTrayTemplateEditState } from './foodTrayTemplateEdit/reducer';
import foodTrayTemplatesReducer, { FoodTrayTemplatesState } from './foodTrayTemplates/reducer';
import foodTypesReducer, { FoodTypesState } from './foodtypes/reducer';
import reportsReducer, { ReportsState } from './reports/reducer';
import snackbarReducer, { SnackbarState } from './snackbar/reducer';
import storeReducer, { StoresState } from './stores/reducer';
import userReducer, { UserState } from './user/reducer';
import usersReducer, { UsersState } from './users/reducer';

export interface AppState {
  snackbar: SnackbarState;
  user: UserState;
  users: UsersState;
  departmentTemplates: DepartmentTemplatesState;
  foodTypes: FoodTypesState;
  stores: StoresState;
  reports: ReportsState;
  foodTrayTemplates: FoodTrayTemplatesState;
  foodTrayTemplateEdit: FoodTrayTemplateEditState;
  feedback: FeedbackState;
}

const rootReducer = combineReducers<AppState>({
  snackbar: snackbarReducer,
  user: userReducer,
  users: usersReducer,
  departmentTemplates: departmentTemplatesReducer,
  foodTypes: foodTypesReducer,
  stores: storeReducer,
  reports: reportsReducer,
  foodTrayTemplates: foodTrayTemplatesReducer,
  foodTrayTemplateEdit: foodTrayTemplateEditReducer,
  feedback: feedbackReducer,
});

export default rootReducer;
